import Component from "./PlanTrackingModal";

export default Component;
